<template>
  <div class="air-table-filter-content">
    <div class="filter-body">
      <div class="top-search">
        <el-input
          v-model="option.data.sVal"
          suffix-icon="el-icon-search"
          @input="searchEvent"
        />
      </div>
      <div class="filter-checkbox-group air-form flex vertical">
        <el-checkbox class="checkbox-plain" v-for="(item, index) in valList" :key="index" v-model="item.checked">{{ item.value }}</el-checkbox>
      </div>
    </div>
    <div class="filter-footer flex jbetween acenter">
      <el-button type="text" class="text-button-filter" @click="resetFilterEvent">重置</el-button>
      <el-button type="primary" @click="confirmFilterEvent">筛选</el-button>
    </div>
  </div>
</template>

<script>
import XEUtils from 'xe-utils'

export default {
  name: 'FilterContent',
  props: {
    params: Object
  },
  data () {
    return {
      size: 'mini',
      isAll: false,
      option: null,
      colValList: [],
      valList: [],
      checkedList: []
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      const { $table, column } = this.params
      const { fullData } = $table.getTableData()
      const option = column.filters[0]
      const { vals } = option.data
      const colValList = Object.keys(XEUtils.groupBy(fullData, column.property)).filter(val => val).map(val => {
        return {
          checked: vals.includes(val),
          value: val
        }
      })
      option.data.sVal = ''
      this.option = option
      this.colValList = colValList
      this.valList = colValList
    },
    searchEvent () {
      const { option, colValList } = this
      this.valList = option.data.sVal ? colValList.filter(item => item.value.indexOf(option.data.sVal) > -1) : colValList
    },
    changeAllEvent () {
      const { isAll } = this
      this.valList.forEach(item => {
        item.checked = isAll
      })
    },
    confirmFilterEvent (evnt) {
      const { params, option, valList, colValList } = this
      const { data } = option
      const { $panel } = params
      data.vals = valList.filter(item => item.checked).map(item => item.value)
      if (!colValList.length || !data.vals.length) {
        this.resetFilterEvent()
        return
      }
      $panel.changeOption(evnt, true, option)
      $panel.confirmFilter()
    },
    resetFilterEvent () {
      const { $panel } = this.params
      $panel.resetFilter()
    }
  }
}
</script>

<style lang="scss" scoped>
.vxe-table--filter-wrapper {
  width: min-content;
}
.air-table-filter-content {
  padding: 8px 0 12px 0;
  user-select: none;

  .filter-body {
    .top-search {
      padding: 0 3px 0 12px;

      ::v-deep .el-input {
        font-size: 12px;
        height: 26px;
        background: #F4F4F4;
        border-radius: 4px;
        min-width: 140px;

        .el-input__inner {
          font-size: 12px;
          border: none;
          height: 26px;
          line-height: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3C475F;
          background: #FFFFFF;
          padding-left: 0;
          border-radius: 4px;
        }

        .el-input__icon {
          line-height: 27px;
        }
      }
    }
    .filter-checkbox-group {
      max-height: 90px;
      overflow-y: scroll;
      margin-top: 7px;

      .el-checkbox {
        flex: 0 0 30px;
        height: 30px;
        padding: 0 12px;
        margin: 0;

        .el-checkbox__label {
          color: #666666;
        }
        &:hover {
          background-color: #EEF3FF;
          border-radius: 0;
        }
      }
    }
  }

  .filter-footer {
    padding: 0 12px;
    margin-top: 8px;
  }
}
</style>
